<template>
  <!-- eslint-disable -->
  <div
    class="bg-white shadow rounded px-3 pt-3 pb-5 border border-white"
    :style="{
      'border-left-color': badgeColor + '!important',
      'border-left-width': '4px !important',
    }"
  >
    <div class="flex justify-between">
      <p
        class="text-black font-semibold font-sans tracking-wide text-sm config-titulo"
      >
        {{ task.titulo }}
      </p>

      <template v-if="task.tb_itembacklogsprint[0].tb_responsavel.length > 0">
        <div class="avatar-container">
          <img
            v-for="responsavel in task.tb_itembacklogsprint[0].tb_responsavel.slice(
              0,
              3
            )"
            :key="responsavel.usuario_git"
            class="w-6 h-6 rounded-full avatar-margin"
            :src="responsavel.tb_usuario.img_url"
            :title="responsavel.tb_usuario.usuario_git"
          />
        </div>
      </template>
      <template v-else>
        <img
          style="visibility: hidden"
          class="w-6 h-6 rounded-full ml-3"
          alt="Avatar"
        />
      </template>
    </div>
    <p
      class="text-gray-700 font-semibold font-sans tracking-wide text-sm"
      :class="'config-text'"
    >
      {{ task.descricao }}
    </p>
    <div class="flex mt-4 justify-between items-center">
      <span class="text-sm text-black"
        ><v-icon> {{ badgePrioridade }} </v-icon>{{ task.prioridade }}</span
      >
      <badge v-if="task.tipo_tarefa" :color="badgeColor">{{
        task.tipo_tarefa
      }}</badge>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/BadgeInfo.vue';

export default {
  components: {
    Badge,
  },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    badgeColor() {
      const mappings = {
        TECNICA: '#800080', // Purple
        DOCUMENTACAO: '#0000ff', // Azul
        IMPLEMENTACAO: '#008080', // Teal
        TESTE_INDEPENDENTE: '#ffa500', // Laranja
        TESTE_EQUIPE: '#008000', // Verde
        CORRECAO_BUG: '#ff0000', // Vermelho
        default: '#ffffff',
      };

      return mappings[this.task.tipo_tarefa] || mappings.default;
    },
    badgePrioridade() {
      const mappings = {
        URGENTE: 'mdi-chevron-double-up',
        ALTA: 'mdi-chevron-up',
        MEDIA: 'mdi-minus',
        BAIXA: 'mdi-chevron-down',
      };

      return mappings[this.task.prioridade];
    },
  },
};
</script>
<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

.config-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 10px;
  height: 50px;
}
.config-titulo {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 215px;
}
.avatar-container {
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: flex-end;
  min-width: 24px;
  max-width: 52px;
  flex-grow: 1;
}
.avatar-margin {
  margin-left: -10px;
}

.avatar-margin:nth-of-type(1) {
  z-index: 3;
  margin-left: 0;
}
.avatar-margin:nth-of-type(2) {
  z-index: 2;
}
.avatar-margin:nth-of-type(3) {
  z-index: 1;
}
.avatar-margin:nth-of-type(4) {
  opacity: 0;
}
</style>
